export default class Util {
  /**
  * @description Returns an include statement that holds the user's main Organization
  **/
  static getOrganizationInclude (models, user, host = 'localhost',
    exclude = ['stripeSecretKey', 'sendGridKey', 'name']) {
    return new Promise((resolve, reject) => {
      this.getOrganization(models, user, host, exclude).then(function (organization) {
        let include = {
          model: models.Organization,
          include: { model: models.AmazonImage, as: 'OrganizationLogo' },
          where: { uuid: organization.uuid },
          attributes: {
            exclude
          }
        }
        resolve(include)
      })
    })
  }

  /**
  * @description Returns an include statement that holds all of user's Organizations
  **/
  static getOrganizationsInclude (models, user, host = 'localhost',
    exclude = ['stripeSecretKey', 'sendGridKey', 'name']) {
    return new Promise((resolve, reject) => {
      this.getOrganizations(models, user, host, exclude).then(function (organizations) {
        let $in = organizations.map(function (org) { return org.uuid })
        let include = {
          model: models.Organization,
          include: { model: models.AmazonImage, as: 'OrganizationLogo' },
          where: { uuid: $in },
          attributes: {
            exclude
          }
        }
        resolve(include)
      })
    })
  }

  /**
  * @description Returns the main OrganizationUuid of the user
  **/
  static getOrganizationUuid (models, user, host = 'localhost',
    exclude = ['stripeSecretKey', 'sendGridKey', 'name']) {
    return new Promise((resolve, reject) => {
      this.getOrganization(models, user, host, exclude).then(function (organization) {
        resolve(organization.uuid)
      })
    })
  }

  /**
  * @description Returns the main Organization of the user
  **/
  static getOrganization (models, user, host = 'localhost',
    exclude = ['stripeSecretKey', 'name']) {
    return new Promise((resolve, reject) => {
      this.getOrganizations(models, user, host, exclude).then(function (organizations) {
        organizations.forEach(function (organization) {
          if (organization.Members && organization.Members[0].MemberContract.mainContract) {
            resolve(organization)
          }
        })
        resolve(organizations[0])
      })
    })
  }

  /**
  * @description Returns all Organizations of the user
  **/
  static getOrganizations (models, user, host = 'localhost',
    exclude = ['stripeSecretKey', 'sendGridKey']) {
    if (user && user.uuid) {
      return models.Organization.findAll({
        include: [
          {
            model: models.Account,
            through: {
              model: models.MemberContract
            },
            where: {
              uuid: user.uuid
            },
            as: 'Members'
          },
          { model: models.AmazonImage, as: 'OrganizationLogo' }
        ],
        attributes: {
          exclude
        }
      })
    } else {
      return models.Organization.findAll({
        where: {
          name: { $contains: [host] }
        },
        include: { model: models.AmazonImage, as: 'OrganizationLogo' },
        attributes: {
          exclude
        }
      })
    }
  }

  static round (num) {
    return Number(Math.round(num + 'e2') + 'e-2')
  }

  static calculateCosts (rate, start, end, extras, extraCredit, alreadyPaid, createdAt, useCredits = true, now = new Date(), percentDiscount = 0) {
    let moment = require('moment-timezone')
    const START_TIME = moment(start).tz(rate.car.Lot.timezone)
    const END_TIME = moment(end).tz(rate.car.Lot.timezone)
    const FRIDAY = 5
    const LAST_FRIDAY = -2
    const OVERNIGHT_START = 17
    const OVERNIGHT_END = 8
    const OVERNIGHT_RATE = this.round(rate.rate.overnightRate)
    let cost = {
      days: 0,
      hours: 0,
      weekendDays: 0,
      overnightHours: 0,
      hourlySubTotal: 0,
      dailySubTotal: 0,
      weekendSubTotal: 0,
      overnightSubTotal: 0,
      extras: 0,
      subTotalCost: 0,
      totalCost: 0,
      startTime: START_TIME,
      endTime: END_TIME,
      originalCredit: this.round(rate.credit) || 0,
      remainingCredit: this.round(rate.credit) || 0,
      extraCredit: this.round(extraCredit) || 0,
      alreadyPaid: this.round(alreadyPaid) || 0,
      creditUsed: 0,
      premiumAmount: 0,
      premiumReason: '',
      percentDiscount,
      preDiscountCost: 0
    }
    let hours = moment(END_TIME).diff(moment(START_TIME), 'hours', true)
    let totalBookingHours = hours
    let totalBookingDays = Math.ceil(hours / 24.00)
    if (rate.car.Lot.hasWeekend) {
      let weekendFactor = Math.floor(totalBookingDays / 5)
      for (let i = 0; i <= weekendFactor; i++) {
        let bookingWeekStart = moment(START_TIME).add(i * 5, 'days')
        let bookingWeekEnd = moment(bookingWeekStart).add(5, 'days')
        if (bookingWeekEnd.isAfter(END_TIME)) bookingWeekEnd = END_TIME
        let day = FRIDAY
        if (bookingWeekStart.day() === 0) day = LAST_FRIDAY
        let weekendStrt =
          bookingWeekStart.clone().day(day).set({'hour': 17, 'minute': 0})
        let weekendEnd =
          weekendStrt.clone().day(8).set({'hour': 8, 'minute': 0})
        if (bookingWeekStart.isBetween(weekendStrt, weekendEnd, null, '[]')) {
          weekendStrt = bookingWeekStart
        }
        if (bookingWeekEnd.isBetween(weekendStrt, weekendEnd, null, '[]')) {
          weekendEnd = bookingWeekEnd
        }
        let overWeekend =
          weekendStrt.isBetween(bookingWeekStart, bookingWeekEnd, null, '[]') ||
          weekendEnd.isBetween(bookingWeekStart, bookingWeekEnd, null, '[]')
        let saturday = 6
        if (weekendStrt.day() === 0) saturday = -1
        let sat930 =
          weekendStrt.clone().day(saturday)
            .set({'hour': 21, 'minute': 30, 'second': 0})
        if (overWeekend) {
          hours =
            bookingWeekEnd.diff(moment(bookingWeekStart), 'hours', true)
          let lowerHours = 0
          let upperHours = 0
          if (bookingWeekStart.isSameOrBefore(weekendStrt)) {
            lowerHours =
              Math.abs(bookingWeekStart.diff(weekendStrt, 'hours', true))
          }
          if (bookingWeekEnd.isSameOrAfter(weekendEnd)) {
            upperHours =
              Math.abs(weekendEnd.diff(bookingWeekEnd, 'hours', true))
          }
          let totalWeekendHours = hours - upperHours - lowerHours
          if (totalWeekendHours >= 27.5) {
            cost.weekendDays++
            totalBookingHours -= totalWeekendHours
          } else if (i < weekendFactor && END_TIME.isSameOrAfter(sat930)) {
            totalBookingHours -= totalWeekendHours
          } else if (i === weekendFactor && START_TIME.isSameOrBefore(sat930) && bookingWeekStart.isSameOrAfter(sat930)) {
            totalBookingHours -= totalWeekendHours
          }
        }
      }
    }
    if (rate.car.Lot.hasOvernight) {
      let overnightStart =
        END_TIME.clone()
        .set({'hour': OVERNIGHT_START, 'minute': 0, 'second': 0})
      if (overnightStart.isSameOrAfter(END_TIME)) {
        overnightStart.subtract(1, 'days')
      }
      let overnightEnd =
          overnightStart.clone().add(1, 'days')
          .set({'hour': OVERNIGHT_END, 'minute': 0, 'second': 0})
      let isOverNight =
        START_TIME.isBetween(overnightStart, overnightEnd, null, '[]') &&
        END_TIME.isBetween(overnightStart, overnightEnd, null, '[]')
      if (isOverNight && totalBookingHours >= 6) {
        cost.overnightSubTotal = OVERNIGHT_RATE
        cost.overnightHours++
        totalBookingHours = 0
      }
    }
    cost.days = this.round(Math.floor(totalBookingHours / 24.00))
    cost.hours = this.round(totalBookingHours - cost.days * 24)
    cost.dailySubTotal = this.round(rate.rate.dailyRate * cost.days)
    cost.hourlySubTotal = this.round(rate.rate.hourlyRate * cost.hours)
    if ((cost.hourlySubTotal) > this.round(rate.rate.dailyRate)) {
      cost.days++
      cost.hours = 0
      cost.dailySubTotal = this.round(rate.rate.dailyRate * cost.days)
      cost.hourlySubTotal = this.round(rate.rate.hourlyRate * cost.hours)
    }
    if (rate.car.Lot.premiumReason && rate.car.Lot.premiumAmount) {
      if (this.round(rate.rate.dailyRate) === 0 && this.round(rate.rate.hourlyRate) === 0) {
        rate.car.Lot.premiumAmount = 0
      }
      let premiumIncluded = false
      for (let i = 0; i < extras.length; i++) {
        if (extras[i].uuid === 'lot-premium') {
          premiumIncluded = true
        }
      }
      if (!premiumIncluded) {
        extras.push({
          uuid: 'lot-premium',
          description: rate.car.Lot.premiumReason,
          name: rate.car.Lot.premiumName,
          cost: this.round(rate.car.Lot.premiumAmount),
          rateType: 'fixed'
        })
      }
    }
    if (extras.length > 0) {
      extras.forEach(extra => {
        if (!extra.overnightRate) {
          extra.overnightRate = this.round(extra.cost)
        }
        if (extra.rateType === 'fixed') {
          cost.extras += this.round(extra.cost)
        } else if (extra.rateType === 'rate') {
          cost.extras +=
            this.round(cost.weekendDays) * this.round(extra.weekendRate) +
              this.round(cost.days) * this.round(extra.dailyRate) +
                this.round(cost.hours) * this.round(extra.hourlyRate) +
                  this.round(cost.overnightHours) * this.round(extra.overnightRate)
        }
      })
    }
    cost.weekendSubTotal = this.round(rate.rate.weekendRate * cost.weekendDays)
    cost.preDiscountCost = this.round(cost.dailySubTotal + cost.hourlySubTotal + cost.overnightSubTotal + cost.weekendSubTotal + cost.extras)
    if (cost.percentDiscount > 0) {
      let discountFactor = (100 - cost.percentDiscount) / 100
      cost.subTotalCost = this.round((cost.dailySubTotal + cost.hourlySubTotal) * discountFactor) +
        this.round(cost.extras + cost.overnightSubTotal + cost.weekendSubTotal)
    } else {
      cost.subTotalCost = cost.preDiscountCost
    }
    let refundCharge = true
    if (createdAt) {
      now = moment(now)
      let reservationStartM = moment(START_TIME)
      let creationDateM = moment(createdAt)
      if (reservationStartM.diff(now, 'hours') < 24) {
        // reservation begins in less than 24 hours
        if (now.diff(creationDateM, 'hours') >= 1) {
          // reservation was also created more than an hour ago
          refundCharge = false
        }
      }
    }
    let credit = this.round(cost.originalCredit + cost.extraCredit)
    if (!this.round(rate.rate.dailyRate) && !this.round(rate.rate.hourlyRate) && cost.originalCredit < 0) {
      useCredits = false
    }
    if (useCredits) {
      if (cost.subTotalCost >= credit + cost.alreadyPaid) {
        cost.totalCost = this.round(cost.subTotalCost - this.round(credit + cost.alreadyPaid))
        cost.remainingCredit = 0
        cost.creditUsed = this.round(credit)
      } else if (refundCharge) {
        cost.totalCost = 0
        cost.remainingCredit = this.round(this.round(credit + cost.alreadyPaid) - cost.subTotalCost)
        cost.creditUsed = this.round(credit - cost.remainingCredit)
      } else if (cost.subTotalCost > cost.alreadyPaid) {
        let owing = cost.subTotalCost - cost.alreadyPaid
        if (owing > credit) {
          cost.totalCost = this.round(owing - credit)
          cost.remainingCredit = 0
          cost.creditUsed = this.round(credit)
        } else {
          cost.totalCost = 0
          cost.remainingCredit = this.round(credit - owing)
          cost.creditUsed = this.round(credit - cost.remainingCredit)
        }
      } else {
        cost.totalCost = 0
        cost.remainingCredit = cost.originalCredit
        cost.creditUsed = 0
      }
    } else {
      cost.totalCost = this.round(cost.subTotalCost - this.round(cost.alreadyPaid))
    }
    if (cost.totalCost <= 5 && cost.totalCost > 0 && useCredits) {
      cost.remainingCredit = -cost.totalCost
      cost.creditUsed += cost.totalCost
      cost.totalCost = 0
    }
    if (cost.weekendSubTotal === 0) {
      rate.rate.weekendRate = 0
    }
    if (cost.overnightSubTotal === 0) {
      rate.rate.overnightRate = 0
    }
    if (cost.originalCredit < 0 && !useCredits && this.round(rate.rate.dailyRate) > 0 && this.round(rate.rate.hourlyRate) > 0) {
      cost.totalCost += Math.abs(cost.originalCredit)
      cost.remainingCredit = 0
    }
    return { rate, cost, extras }
  }

  /**
  *  @desc Calculates distance in metres between 2 coordinates
  *  @return Returns the distance in metres
  */
  static calculateDistance (position1, position2) {
    const R = 6378.137
    let lat1 = position1.latitude
    let lat2 = position2.latitude
    let lon1 = position1.longitude
    let lon2 = position2.longitude
    let dLat = (lat2 - lat1) * Math.PI / 180
    let dLon = (lon2 - lon1) * Math.PI / 180
    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2)
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    let distance = R * c * 1000
    return distance
  }

  /**
  *  @desc Finds all accounts that want to be notified of an event
  *  @return Returns the emails of the accounts to be used to send emails
  */
  static async sendNotifications (models, name, messageParams, orgUuid) {
    let bannerAccounts = await models.Account.findAll({
      include: [
        {
          model: models.Organization,
          through: {
            model: models.MemberContract
          },
          as: 'Contracts',
          where: { uuid: orgUuid }
        },
        {
          model: models.Alert,
          where: {
            name,
            type: 'banner'
          }
        }
      ],
      attributes: ['uuid']
    })
    let popUpAccounts = await models.Account.findAll({
      include: [
        {
          model: models.Organization,
          through: {
            model: models.MemberContract
          },
          as: 'Contracts',
          where: { uuid: orgUuid }
        },
        {
          model: models.Alert,
          where: {
            name,
            type: 'popUp'
          }
        }
      ],
      attributes: ['uuid']
    })
    let emailAccounts = await models.Account.findAll({
      include: [
        {
          model: models.Organization,
          through: {
            model: models.MemberContract
          },
          as: 'Contracts',
          where: { uuid: orgUuid }
        },
        {
          model: models.Alert,
          where: {
            name,
            type: 'email'
          }
        }
      ],
      attributes: ['email', 'uuid']
    })
    let emails = emailAccounts.map(function (el, i, arr) {
      return el.email
    })
    if (bannerAccounts.length > 0) {
      messageParams.type = ['banner']
      let bannerMessage = await models.AccountMessage.create(messageParams)
      await bannerMessage.setAccounts(bannerAccounts)
    }
    if (popUpAccounts.length > 0) {
      messageParams.type = ['loginMessage']
      let popUpMessage = await models.AccountMessage.create(messageParams)
      await popUpMessage.setAccounts(popUpAccounts)
    }
    if (emailAccounts.length > 0) {
      messageParams.type = ['email']
      messageParams.message = '<span class="fa fa-paper-plane-o"></span> Email Notification Was Sent'
      let emailMessage = await models.AccountMessage.create(messageParams)
      await emailMessage.setAccounts(emailAccounts)
    }
    return emails
  }
}



// WEBPACK FOOTER //
// ./server/util/index.js